import createSagaMiddleware from "redux-saga";
import Raven from "../services/raven";

const sagaMiddleware = createSagaMiddleware({
  onError: error => {
    Raven.captureException(error);
  },
});

export const runSaga = (...props) => sagaMiddleware.run(...props);

export default sagaMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/sagasMiddleware.js